"use client";

import { useEffect } from "react";

const AlertModal = ({
  showModal,
  toggleModal,
  content,
  modalTitle,
  modalSize,
  iconType,
  children,
}) => {
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  const getIcon = () => {
    switch (iconType) {
      case "error":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1}
            stroke="currentColor"
            className="mx-auto mb-4 size-32 text-red-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
            />
          </svg>
        );
      case "warning":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1}
            stroke="currentColor"
            className="mx-auto mb-4 size-32 text-yellow-500"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`fixed inset-0 z-2000 flex items-center justify-center bg-gray-800/50 ${
        showModal ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      } backdrop-blur transition-opacity duration-300`}
      onClick={toggleModal}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative transform rounded-lg bg-white p-6 shadow-lg transition-transform duration-300 ${modalSize} max-w-[90%] sm:max-w-[80%] lg:max-w-[50%] ${
          showModal ? "scale-100" : "scale-95"
        }`}
      >
        {iconType && getIcon()}
        {modalTitle && (
          <h3 className="pt-2 text-center text-2xl font-semibold sm:text-3xl">{modalTitle}</h3>
        )}
        <div>{content}</div>
        {children}
      </div>
    </div>
  );
};

export default AlertModal;
